<template>
    <div>
        <div class="row">
            <div class="col">
                <q-item-label class="text-body1">
                    It appears that our system unable to retrieve your Email Address or Mobile Number!! Please update your info accordingly, so that you may continue your transaction(s) without any hiccups.
                </q-item-label>
            </div>
        </div>
            <div class="row">
                <div class="col-12 col-md-9 ">
                    <q-input
                        filled
                        lazy-rulesss :rules="[val => !!val || 'Field is required']" 
                        
                        v-model="StoreStateAO.ContactInformation.MobileNo"
                        label="HP : 1234567890"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-9  ">
                    <q-input
                        filled
                        lazy-rulesss :rules="[val => !!val || 'Field is required']" 
                        v-model="StoreStateAO.ContactInformation.EmailAddress"
                        type="email" label="Email Address" 
                    />
                </div>
        </div>
        
    </div>
</template>

<script>
import store from '../store'
import { mapState, mapActions } from "vuex";

export default {
    name: 'BasisRecommendation',
    data() {
        return {
            StoreStateLookup : store.state.Lookup,
            StoreStateAD : store.state.AD,
            StoreStateFATCA : store.state.FATCA,
            StoreStateED : store.state.ED,
            StoreStateAO : store.state.AOD,
            StoreStateCD : store.state.CD,
            StoreStateTransaction : store.state.Transactions,
            StoreStateAPI : store.state.API,
            StoreStateLogin: store.state.Login,
       }
    },
    methods: {
    }
}
</script>